<template>
  <b-card no-body>
      <!-- Card body -->
      <b-card-body>
          <div class="loader" v-if="loading"></div>
          <b-card-title class="h2 mb-0">Your Art Book {{ titleOrPlaceholder() }}</b-card-title>
          <!-- small class="text-muted">
            {{ showIsbn() }} last change: {{ formatDate(currentBook.updated_at) }} | Your editorial assistant: {{ currentBook.editor }}
          </small -->
          <small class="text-muted">
           Your editorial assistant: {{ currentBook.editor }}
          </small>
          <b-card-text class="mt-4">
              Your next step is:
              <strong>{{ currentBook.written_next_step }}</strong>
              <!-- strong>{{ currentBook.written_next_step }} {{ currentBook.next_step }} {{ currentBook.state }}</strong -->
          </b-card-text>
          <a :href="'#/artist/'+currentBook.id+'/wizard'" class="btn btn-sm btn-dark" v-if="mayContinue">Continue Art Book</a>
      </b-card-body>
  </b-card>

</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
import CurrentPhotoBook from "./CurrentPhotoBook.vue";

export default {
  name: "wizard-photo-book-card",
  data() {
    return {
      loading: false,
      currentBook: [],
    };
  },
  props: {
      photoBookId: '',
  },
  methods: {
    retrieveBook() {
      this.loading = true;
      this.$api.getPhotoBook(this.photoBookId)
        .then((response) => {
          console.log(response);
          this.currentBook = response.data;
          console.log(this.currentBook);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY")
    },
    titleOrPlaceholder(){
      // Check if title exists and is not null/empty
      if(this.currentBook.title && this.currentBook.title.trim() !== ''){
        return "'"+this.currentBook.title+"'";
      }
      else if(this.currentBook.id){
        return "#"+this.currentBook.id;
      }
      else{
        return "";
      }
    },
    showIsbn(){
      if(this.currentBook.isbn != ""){
        return "ISBN: "+this.currentBook.isbn +" | ";
      }
    },
  },
  computed: {
      ...mapGetters({ currentAccount: 'currentAccount'}),
      bookLoaded: function () {
          return this.currentBook ? true : false;
      },
      mayContinue(){
        if(this.currentBook.next_step == "5"){
          return false
        }
        if(this.currentBook.next_step == "7"){
          return false
        }
        return true
      }
  },
  mounted() {
      this.retrieveBook();
      console.log("CURRENTBOOK NEXT STEP ----> "+this.currentBook.next_step);
  },
};
</script>
<style></style>